module.exports = __webpack_public_path__ + "img/jcb.fc39de6d.svg";